<template>
    <v-app light>
        <v-content>
            <v-container class="page-container">

                <v-layout>
                    <v-flex>
                        <header class="header">
                            <a href="https://www.hse.ru/" target="_blank" class="main-page__link main-page__link--1"></a>
                            <a href="https://ioe.hse.ru/" target="_blank" class="main-page__link main-page__link--2"></a>
                            <div>
                                <h1 class="display-1">Система оценки ключевых компетенций SMART</h1>
                                <span>Skills Monitoring of Adults for Research and Transformation</span>
                            </div>
                        </header>
                        <div class="content main-text">
                            Навыки – новая валюта XXI века. Вы не сразу поверите этому? Тогда почитайте биографии великих и успешных людей в бизнесе: все они, не имея изначального доступа ни к капиталу, ни к средствам производства, работая «в гараже», смогли начать новые проекты, создать всемирно-известные компании и добиться успеха. Их навыки и решили все!
                        </div>
                    </v-flex>
                </v-layout>

                <v-layout row wrap>
                    <v-flex xs12 md6>
                        <div class="mb-4">
                            <h4>Когнитивные навыки являются источником успешности в развивающемся мире</h4>
                            <div class="content">
                                <p>
                                    <img class="float-right" src="./assets/i1.jpg"/>
                                    Современная инновационная экономика принесла в жизнь новые вызовы. Согласно последним данным опросов работодателей в условиях высокотехнологического производства «период жизни» полученного в результате обучения навыка стремительно уменьшается и составляет около 5 лет, а у разработчиков программного обеспечения его актуальность еще меньше – всего 1-1,5 года<sup>1</sup>. Таким образом, полученные знания и умения устаревают быстрее, чем человек переходит к выполнению трудовых обязательств. Но что же тогда является ценностью?</p>
                                <div v-if="blocks.show1">
                                    <p>Еще Альберт Эйнштейн некогда заметил, что «образование есть то, что остается, когда все выученное забыто». Следуя его логике, приходится объективно признать, что ключевым результатом образования является не запоминаемый объем фактологического материала или последовательности событий и действий, а достигнутый уровень мыслительных (когнитивных) способностей человека – умение думать, работать с информацией, выстраивать последовательность действий, планировать ход решения задачи.</p>
                                    <p>Экономические исследования, проведенные за последние 10 лет с использованием тестовых систем оценки мыслительной активности человека, показали удивительные результаты. Оказалось, что когнитивные навыки в значительной степени определяют занятость и уровень заработной платы работника, удовлетворенность трудовой деятельностью и способность соответствовать профессиональному стандарту<sup>2</sup>. Важно еще и то, что с ростом уровня когнитивных способностей, люди легче ликвидируют дефициты любых других навыков, понимают необходимость освоения новых или даже осваивают их путем самообразования. Именно сотрудники с наиболее высоким уровнем когнитивных навыков обеспечивают высокую производительность труда и составляют основной интеллектуальный и человеческий капитал компании. Они всегда востребованы и нужны своему окружению. Но и это еще не все.</p>
                                    <p>Проведенные Организацией экономического сотрудничества и развития (ОЭСР) исследования показывают, что работники с высоким когнитивным уровнем чаще участвуют в волонтерских проектах, у них высокий уровень доверия к институтам, они чаще выступают в качестве получателей наград и, наконец, они более здоровы и дольше живут<sup>3</sup>.</p>
                                    <p><b>Как узнать свои когнитивные навыки (Cognitive Skills)?</b> Измерение когнитивных навыков человека включает в себя оценивание его активности по следующим параметрам:</p>
                                    <p>
                                        <img class="float-right" src="./assets/i2.jpg"/>
                                        Наличие навыков работы с текстовой информацией (Literacy) показывает уровень понимания текстов (инструкций, писем, руководств) для достижения профессиональных целей, развития знаний и трудового потенциала. Уровень владения данными навыками также свидетельствует о знании русского языка, внимании к поручениям и развитости памяти в целом.</p>
                                    <p>Уровень владения навыками работы с числовой информацией (Numeracy) показывает способность понимать, интерпретировать и пользоваться математической информацией, применять эти знания в широком жизненном контексте, а также позволяет оценить уровень абстрактного мышления, следования правилам математической логики.</p>
                                    <p>Уровень владения навыками решения задач в технологически насыщенной среде (PSTRE-problem solving in technology rich-environments) определяет потенциал человека в умении собирать, использовать и обрабатывать информацию для решения различных организационных задач. Использование интерфейсов и симуляторов распространенных электронных сервисов в структуре тестовых заданий позволяет также оценить компьютерную грамотность работника в целом и показывает наличие компетенций, необходимых для деятельности в условиях цифровой экономики.</p>
                                    <p>Попробуем? Предлагаемая здесь тестовая система определит высокопотенциальных сотрудников, выявит группы риска, оценит использование работниками практик повышения производительности труда в их повседневной деятельности, а также покажет их потребности в образовании и обучении.</p>

                                    <div class="content-description">
                                        <p>1) B. Pelster, D. Johnson, J. Stempel, B. v.d. Vyver. Careers and learning in Deloitte Global Human Capital Trends//Deloitte University Press. pp.29 – 37. <a href="dupress.deloitte.com" target="_blank">dupress.deloitte.com</a></p>
                                        <p>2) Heckman J., Stixrud J., Urzua S. (2006) The effects of cognitive and noncognitive abilities on labor market outcomes and social behavior // Journal of Labor Economics. Vol. 24. No. 3. P. 411–482.</p>
                                        <p>3) John P. Martin Skills for the 21st Century: Findings and Policy Lessons from the OECD Survey of Adult Skills</p>
                                    </div>
                                </div>
                                <div class="text-xs-right" v-if="!blocks.show1">
                                    <a class="blue--text" @click="blocks.show1=true">Подробнее</a>
                                </div>
                            </div>
                        </div>

                        <div class="mb-4">
                            <h4>Энергия социально-эмоциональных навыков: вклад в показатели эффективности и производительность труда</h4>
                            <div class="content">
                                <p>
                                    Чтобы производить конкурентоспособный продукт для постоянно меняющегося инновационного рынка надо уметь покупателя удивлять. А для этого необходимо не только знать его потребности, но и быть внимательным, чувствовать желания, вести диалог. Постоянно выяснять, как меняются его запросы и добросовестно трансформировать его ответы в усовершенствования товара, производственного процесса, услуги. Тоже  происходит и внутри компаний. Современный продукт или услуга, чтобы быть выпущенными в новом качестве, столь сложны, что детали их изменений могут быть поняты и приняты к исполнению только в результате серьезной вовлеченности всех членов организационной команды.  Вот почему в составе типов трудовых действий работников с конца 60-х годов интенсивно нарастает число таких производственных операций, которые предусматривают межличностную коммуникацию и взаимодействие.<sup>1</sup>
                                    <img class="max-width" src="./assets/i3.jpg"/>
                                </p>
                                <div v-if="blocks.show2">
                                    <p>
                                        <img class="max-width" src="./assets/i4.jpg"/>
                                        Чтобы дать возможность реализоваться профессиональным навыкам их приходится сочетать как с активной мыслительной деятельностью, так и большим блоком социально-ориентированных универсальных компетенций (навыков 21 века и активной самостоятельности), которые развиваются с использованием основных черт личности (Большая пятерка – Big5): добросовестность, дружелюбие, экстраверсия, открытость новому опыту, эмоциональная стабильность.
                                    </p>
                                    <p>
                                        <img class="max-width" src="./assets/i6.jpg"/>
                                        Эффективность и использование практик повышения производительности труда  (HPWP) напрямую зависят от таких персональных, социально-эмоциональных характеристик, которые усиливают интеграцию и структурирование трудовых коллективов для решения профессиональных задач. Для когорт людей с низкими когнитивными способностями социально-эмоциональные навыки имеют определяющее значение при поиске работы, выстраивании трудовых отношений и полном включении в производственные отношения. <sup>2</sup>
                                    </p>
                                    <p>Оценивание социально-эмоциональных навыков, представляющих собой черты личности, позволяет выделить добросовестных, целеустремленных сотрудников, которые с высокой вероятностью выдерживают жизненные трудности, демонстрируют хорошие показатели в работе. Результаты оценки будут полезны как для выбора индивидуальных профессиональных и образовательных траекторий, так и правильной расстановки кадров hr-менеджерами внутри компании, разработки ими стратегии обучения персонала.</p>
                                    <div class="content-description">
                                        <p>1) David H. Autor and Brendan Price The Changing Task Composition of the US Labor Market: An Update of Autor, Levy, and Murnane (2003). MIT Working Paper, June 2013. <a href="https://economics.mit.edu/files/9758" target="_blank">https://economics.mit.edu/files/9758</a></p>
                                        <p>2) Skills for Social Progress. The Power of Social and Emotional Skills. OECD Skills Studies, OECD Publishing. 2015.</p>
                                    </div>
                                </div>
                                <div class="text-xs-right" v-if="!blocks.show2">
                                    <a class="blue--text" @click="blocks.show2=true">Подробнее</a>
                                </div>
                            </div>
                        </div>

                        <div class="mb-4">
                            <h4>«Век живи – век учись»: пророчества римских мыслителей сбываются</h4>
                            <div class="content">
                                <p>
                                    Философский смысл непрерывного образования заключен в объективной изменчивости нашей жизни. «Век живи – век учись» – говорил Сенека – римский политический деятель и философ. Появление и развитие современной и небывалой по масштабам системы непрерывного образования взрослых связано с революционным характером обновления производственных технологий, и особенно, с формированием цифрового уклада в экономике и просто повседневной жизни. «Бизнес со скоростью мысли» означает, что почти с такой же скоростью работникам придется обновлять навыки, которыми они пользуется в процессе выпуска и обмена товаров, оказания услуг. Вот почему навыки – это новая валюта, которая обеспечивает сегодня процветание как граждан, так и стран в целом. </p>
                                <div v-if="blocks.show3">
                                    <p>Масштабы обучения будут зависеть от того, в какой компании - с каким уровнем менеджмента Вы работаете, в какой отрасли функционирует Ваше предприятие. Однако важно еще вот что. В современном российском обществе мы пока не относимся к образованию как лекарству от неуспешности. А между тем это действительно так. Навыки, получаемые в результате образования – это то, что реально способно обеспечить наш доход и нашу уверенность в завтрашнем дне.</p>
                                    <p>
                                        <img class="float-right" src="./assets/i9.jpg"/>
                                        Попробуйте, например, пройти программу «как работать с трудным начальником» и Ваша каждодневная жизнь изменится в лучшую сторону. А если Вы научитесь компьютерному дизайну или технологиям удаленного проектирования, то сможете, возможно, открыть свое проектно-конструкторское бюро. Курсы стилистов придадут Вам уверенное поведение и создадут имидж успешного человека.</p>
                                    <p>Сегодня, увы, всего 17% российского населения в возрасте 25-64 лет ежегодно участвуют в какого-либо образовательных программах или мероприятиях учебного характера.<sup>1</sup> Для сравнения среднеевропейский показатель охвата взрослых образованием и обучением более 35%, а в странах ОЭСР более 51%. В скандинавских странах он еще выше 60%, а в Швейцарии даже более 70%. Кстати, ровно во столько же раз отличается и производительность труда между этими странами.<sup>2</sup> А, в российских регионах, где взрослые больше учатся, наблюдается более высокий валовой региональный продукт, объем инвестиций в основной капитал и темп прироста реальной заработной платы населения.</p>
                                    <p>
                                        <img class="float-right" src="./assets/i5.jpg"/>
                                        Похоже, что эпоха непрерывного образования действительно становится реальностью. Уже почти 44% студентов американских колледжей старше 25 лет. Более того, в самом ближайшем будущем новые навыки нам придется осваивать каждую свободную минуту: по дороге на работу, домой или даже во время занятия спортом. И причина этого будет проста: тот, кто больше учится – будет жить более качественно и дольше.</p>
                                    <p>Тестовая система, которую Вы собираетесь пройти, позволит Вам задуматься и определить, какое обучение Вам необходимо, какие задачи личностного развития Вы должны решить через образование, повышение квалификации, чтение книг или прохождение онлайн курсов.</p>
                                    <p>Мы желаем Вам найти свой ключ к навыкам и эффективности.</p>
                                    <div class="content-description">
                                        <p>1) Коршунов И.А., Кужелева К.С., Грачев, Б.А., Сергеев К.А. Обучение и образование взрослых: востребованные программы, возрастная и отраслевая структуры // Факты образования. № 1 (16). - М.: НИУ ВШЭ, 2018. — 44 с <a href="https://ioe.hse.ru/data/2018/03/01/1165043209/ФО_1(16)_электронный.pdf" target="_blank">https://ioe.hse.ru/data/2018/03/01/1165043209/ФО_1(16)_электронный.pdf</a></p>
                                        <p>2) Коршунов И.А., Гапонова О.С. Непрерывное образование взрослых в контексте экономического развития и качества государственного управления // Вопросы образования.– 2017.– № 4.– С 36-59</p>
                                    </div>
                                </div>
                                <div class="text-xs-right" v-if="!blocks.show3">
                                    <a class="blue--text" @click="blocks.show3=true">Подробнее</a>
                                </div>
                             </div>
                        </div>

                    </v-flex>

                    <v-flex xs12 md5 offset-md1>
                        <div class="mb-4">
                            <h4>«Ключ» к Вашим навыкам</h4>
                            <div class="content">
                                <p>Самостоятельное прохождение теста без использования ключа (маршрутного кода) позволит Вам получить общую оценку Ваших когнитивных способностей.</p>
                                <p>Прохождение тестирования с использованием ключа (маршрутного кода), сгенерированного администратором, позволяет получить комплекс аналитической информации о сотруднике или кандидате для принятия управленческих решений, а также практические рекомендации их менеджерам по повышению потенциала работников, увеличению производительности труда на предприятиях и в подразделениях. </p>
                            </div>
                        </div>

                        <div class="mb-4">
                            <h4>Вход в систему тестирования</h4>
                            <form-auth></form-auth>
                        </div>

                        <div class="mb-4">
                            <h4>Контактная информация:</h4>
                            <div class="content">
                                Для прохождения тестирования с использованием ключа обратитесь, пожалуйста, письменно к администратору системы оценивания: <a href="mailto:hr.skills-online@yandex.ru">hr.skills-online@yandex.ru</a>
                            </div>
                        </div>

                        <div class="mb-4">
                            <h4>Результаты</h4>
                            <div class="content">
                                <p>
                                    <b>Подготовка аналитических записок</b>
                                </p>
                                <p>
                                    На основании обследования групп респондентов предусматривается возможность подготовки аналитических материалов. Материалы составляются на основании оценивания ключевых компетенций XXI века: навыков работать с текстовой и математической информацией, а также навыка решения организационных задач с использованием интерфейсов.
                                </p>
                                <ul style="margin-left: 1.2rem">
                                    <li><p>Предприятиям предоставляется аналитическая записка, отображающая результаты каждого участника тестирования. Выделяются группы, показавшие наилучшие результаты, а также те, кому необходима образовательная поддержка и вовлечение в командную работу.</p></li>
                                    <li><p>Центрам занятости или муниципальным центрам предоставляются сведения о результатах граждан, оказавшихся в трудной жизненной ситуации. В аналитической записке отображаются рекомендации по эффективному распределению мер социальной поддержки, предусмотренных социальным контрактом.</p></li>
                                </ul>
                                <p>
                                    <a href="https://www.skills-online.ru/%D0%90%D0%BD%D0%B0%D0%BB%D0%B8%D1%82%D0%B8%D1%87%D0%B5%D1%81%D0%BA%D0%B0%D1%8F%20%D0%B7%D0%B0%D0%BF%D0%B8%D1%81%D0%BA%D0%B0%20%D0%BF%D0%BE%20%D1%8D%D1%84%D1%84%D0%B5%D0%BA%D1%82%D0%B8%D0%B2%D0%BD%D0%BE%D0%BC%D1%83%20%D0%B8%D1%81%D0%BF%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D1%8E%20%D0%BC%D0%B5%D1%80%20%D1%81%D0%BE%D1%86%D0%B8%D0%B0%D0%BB%D1%8C%D0%BD%D0%BE%D0%B3%D0%BE%20%D0%BA%D0%BE%D0%BD%D1%82%D1%80%D0%B0%D0%BA%D1%82%D0%B0%20(%D0%B0%D0%BD%D0%BE%D0%BD%D0%B8%D0%BC%D0%B8%D0%B7%D0%B8%D1%80%D0%BE%D0%B2%D0%B0%D0%BD%D0%BD%D0%B0%D1%8F).pdf" style="font-weight: bold; text-decoration: none">Образец аналитической записки</a>, подготовленный на основании результатов обследования граждан, оказавшихся в трудной жизненной ситуации
                                </p>
                                <p>
                                    По вопросам сотрудничества обращайтесь к администратору системы оценивания: <a href="mailto:hr.skills-online@yandex.ru">hr.skills-online@yandex.ru</a>
                                </p>
                            </div>
                        </div>

                        <div class="mb-4">
                            <h4>Новости</h4>
                            <div v-for="(article, i) in news" :key="i">
                                <post-preview :title="article.title" :content="article.content" :image="article.image" :url="article.url"></post-preview>
                            </div>
                        </div>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
    import PostPreview from '@/components/posts/preview'
    import FormAuth from '@/components/auth'
    import data from './data.json'

    export default {
        components: {
            PostPreview,
            FormAuth
        },
        data () {
            return {
                news: data.news,
                blocks: {
                    show1: false,
                    show2: false,
                    show3: false
                }
            }
        },
        props: {},
        computed: {},
        methods: {}
    }
</script>

<style lang="stylus" scoped>
    .header{
        display flex
        flex-flow row nowrap
        align-items center
        padding-bottom 1rem
        margin-bottom 2rem
        margin-top 1rem
        a {
            margin-right 2rem
        }
        h1 {
            margin 0
            color #da805b
            text-shadow black 0 0 1px
            font-weight 500
        }
    }

    h4 {
        font-size 1.8rem
        line-height 2.4rem
        font-weight 500
        margin-bottom 0.8rem
        text-align left
        color #9e1b40
    }

    .main-page__link {
        display inline-block
        text-decoration none
        width 6rem
        height @width
        background no-repeat center center / contain

        &--1 {
            background-image url(/images/hse_ru_logo.svg)
        }

        &--2 {
            background-image url(/images/ioe_logo.png)
        }
    }

    .content {
        text-align justify
        display block
        font-size 1rem

        & > p:last-of-type {
            margin-bottom 0.5rem
        }

        sup {
            font-size 0.6rem
            top -1em
        }
    }

    .display-1 {
        text-align left
    }

    .float-right {
        float right
        margin-left 1rem
        margin-bottom 1rem
        width 50%
        max-width 100%
    }
    .float-left {
        float left
        margin-right 1rem
        margin-bottom 1rem
        width 50%
        max-width 100%
    }
    .max-width {
        display block
        margin 0 auto
        max-width 100%
        width 100%
        margin-bottom 1rem
    }
    .page-container {
        @media only screen and (min-width: 960px) {
            max-width 1200px
        }
    }
    .content-description {
        border-top 1px solid #b1b1b1
        padding-top 1rem
        font-size 0.8rem
        margin-top 1rem
        p {
            text-align left
            margin-bottom 0
        }
    }
    .main-text {
        color #014b8c
        letter-spacing 0.5px
        font-size 1.3rem
        margin-bottom 2rem
        font-style italic
    }
</style>
